import { defaultCardStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsDefaultCard";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import { checkoutBlockTitleStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

const labelStyles: TypographyPresentationProps = {
    weight: TYPOGRAPHY.weight.bold,
    color: COLORS.text.dark,
    css: css`
        margin-bottom: 4px;
    `,
};

Object.assign(defaultCardStyles, {
    titleText: {
        as: "h2",
        css: css`
            margin-top: 35px !important;
            border-bottom: 1px solid ${COLORS.border.base};
            padding-bottom: 15px;
            ${checkoutBlockTitleStyles()}
        `,
    },
    mainWrapper: {
        css: css`
            margin-bottom: 50px;
        `,
    },
    headerWrapper: {
        css: css`
            display: flex;
            margin-bottom: 20px;
        `,
    },
    descriptionText: {
        css: css`
            margin: 5px 10px 10px;
            text-transform: uppercase;
        `,
    },
    nameOnCardLabelText: labelStyles,
    expirationLabelText: labelStyles,
    billingAddressLabelText: labelStyles,
});
